import { useMutation } from '@tanstack/react-query';

import { HttpClient } from '@/network/HttpClient';

type PaymentSystemUrlParams = {
  email?: string | null;
  fetchUrl: string;
  /** Additional data to pass to payment request (for booking) */
  extraData?: Record<string, unknown>;
};

export const useGetPaymentSystemUrl = () => {
  return useMutation({
    mutationFn: (params: PaymentSystemUrlParams) =>
      HttpClient.request<{ payment_url: string }>({
        method: 'GET',
        url: params.fetchUrl,
        params: {
          email: params.email || '',
          ...params.extraData,
        },
      }),
  });
};
